import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'sf-auth-top-bar',
	templateUrl: './auth-top-bar.component.html',
	styleUrls: ['./auth-top-bar.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthTopBarComponent {}
